import { render, staticRenderFns } from "./companyTab.vue?vue&type=template&id=9b71abe0"
import script from "./companyTab.vue?vue&type=script&lang=js"
export * from "./companyTab.vue?vue&type=script&lang=js"
import style0 from "./companyTab.vue?vue&type=style&index=0&id=9b71abe0&prod&scpoed=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports